import React from "react";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState } from "react";
import SureModal from "src/components/Modals/SureModal";
import { stocksAction } from "src/store/Slices/Administrator/StocksSlice";
import AddEditStocksModal from "./Modals/AddEditStocksModal";
import { Image } from "antd";
import fallback from "./fallback.png";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";

const Stocks = ({ mnemo }) => {
    const dispatch = useDispatch();
    const searchInput = useRef(null);

    const items = [
        {
            key: "1",
            label: "Редактировать",
            onClick: () => {
                setIsOpenAddEditModal({ open: true, flag: "edit" });
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
        },
        {
            key: "2",
            label: "Удалить",
            onClick: () => {
                setIsOpenDeleteModal(true);
            },
            disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
        },
    ];

    const filterOptionsArr = [
        { label: "Фильрация", value: 0, index: undefined },
        { label: "По номеру", value: 1, index: "id", title: "Акция" },
        {
            label: "По наименованию",
            value: 2,
            index: "name",
            title: "Наименование",
        },
        {
            label: "По описанию",
            value: 3,
            index: "description",
            title: "Описание",
        },
        {
            label: "По URL изображения",
            value: 4,
            index: "imageUrl",
            title: "URL изображения",
        },
    ];

    const [isDeleted, setIsDeleted] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [stockInfo, setStockInfo] = useState();
    const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
        open: false,
        flag: "",
    });
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    // STORE
    const stocksList = useSelector((state) => state.StocksSlice.stocksList);
    const stocksListLoading = useSelector(
        (state) => state.StocksSlice.stocksListLoading
    );

    const onClickDelete = () => {
        dispatch(
            stocksAction({ flag: "delete", value: { id: stockInfo.id } })
        ).then(() => {
            dispatch(stocksAction({ flag: "get" }));
            setIsOpenDeleteModal(false);
        });
    };

    const showDeletedItems = (value) => {
        setIsDeleted(value);
        dispatch(stocksAction({ flag: "get", value: { isDeleted: value } }));
        setPage(1);
        setPageSize(20);
    };

    const searchItemsMap = (keys, values) => {
        const formattedItems = {};
        if (keys && values) {
            keys.forEach((key, index) => {
                if (values[index] && values[index][0]) {
                    if (key === "id") {
                        formattedItems["idFrom"] = values[index][0];
                        formattedItems["idTo"] = values[index][1];
                    } else if (key === "clubName") {
                        formattedItems["clubId"] = values[index][0];
                    } else {
                        formattedItems[key] = values[index][0];
                    }
                }
            });
            return formattedItems;
        }
    };

    const handleTableChange = (pagination, filters, sorter) => {
        const payload = searchItemsMap(
            Object.keys(filters),
            Object.values(filters)
        );
        dispatch(
            stocksAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    count: pagination.pageSize,
                    offset: pagination.pageSize * (pagination.current - 1),
                    orderBy: sorter?.column?.dataIndex,
                    isDesc: sorter.order
                        ? sorter.order === "ascend"
                            ? true
                            : false
                        : undefined,
                    ...payload,
                },
            })
        );
        setPage(pagination.current);
        setPageSize(pagination.pageSize);
    };

    const clickOnAction = (element) => {
        setStockInfo(element);
    };

    const handlePaginationChange = (page, pageSize) => {
        dispatch(
            stocksAction({
                flag: "get",
                value: {
                    count: pageSize,
                    offset: pageSize * (page - 1),
                },
            })
        );
        setPage(page);
        setPageSize(pageSize);
    };

    const onClickSearchItem = (selectedKeys, dataIndex) => {
        setPage(1);
        setPageSize(20);
        dispatch(
            stocksAction({
                flag: "get",
                value: {
                    isDeleted: isDeleted,
                    [`${dataIndex}`]: selectedKeys[0],
                },
            })
        );
    };

    useEffect(() => {
        dispatch(stocksAction({ flag: "get" }));
    }, []);

    const formatedRows = stocksList?.data?.value?.rows.map((element) => {
        return {
            ...element,
            imageUrl: (
                <Image
                    alt="Отсутствует изображение"
                    width={120}
                    src={element?.imageUrl}
                    fallback={
                        fallback || "https://placehold.co/400x400?text=No+Photo"
                    }
                />
            ),
        };
    });

    return (
        <>
            <AddEditStocksModal
                visible={isOpenAddEditModal}
                setVisible={setIsOpenAddEditModal}
                stockInfo={stockInfo}
            />
            <SureModal
                visible={isOpenDeleteModal}
                setVisible={setIsOpenDeleteModal}
                onClickYes={onClickDelete}
            />
            {window.innerWidth >= 768 ? (
                <AdminTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    onChange={handleTableChange}
                    loading={stocksListLoading}
                    onClickRowOne={(record) => {
                        setStockInfo(record);
                    }}
                    columns={stocksList}
                    rows={formatedRows}
                    total={stocksList?.data?.value?.totalCount}
                    title={() => (
                        <TableTitle
                            isDeleted={isDeleted}
                            showDeletedItems={showDeletedItems}
                            onClickOpenModal={() => {
                                setIsOpenAddEditModal({
                                    open: true,
                                    flag: "add",
                                });
                            }}
                            mnemoButton={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "insertBtn"
                                )
                            }
                            mnemoSwitcher={
                                !mnemo?.children?.find(
                                    (el) => el.mnemo === "isDeletedBtn"
                                )
                            }
                        />
                    )}
                    items={items}
                    isDeleted={isDeleted}
                />
            ) : (
                <AntdMobileTable
                    page={page}
                    setPage={setPage}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    elementsList={stocksList}
                    elementsListLoading={stocksListLoading}
                    setIsOpenAddEditModal={setIsOpenAddEditModal}
                    setIsOpenDeleteModal={setIsOpenDeleteModal}
                    items={items}
                    filterOptionsArr={filterOptionsArr}
                    handlePaginationChange={handlePaginationChange}
                    onChange={handleTableChange}
                    clickOnAction={clickOnAction}
                    searchInput={searchInput}
                    onClickSearchItem={onClickSearchItem}
                />
            )}
        </>
    );
};

export default Stocks;
